<template>
  <el-form ref="form" :model="config" :rules="rules" label-width="100px">
    <el-form-item label="类型" prop="type">
      <el-select v-model="curInput.deal_time.type" placeholder="请选择类型" class="h-40 w-200">
        <el-option v-for="item in typeOptions" :label="item.name" :value="item.id"></el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="最小单位" prop="unit">
      <el-select v-model="curInput.deal_time.unit" placeholder="请选择最小单位" class="h-40 w-200">
        <el-option v-for="item in unitOptions" :label="item.name" :value="item.id"></el-option>
      </el-select>
    </el-form-item>
  </el-form>
</template>

<script>
  export default {
    props: ['curInput'],
    data() {
      return {
        typeOptions: [
          { id: 10, name: '创建时间' },
          { id: 20, name: '操作时间' }
        ],
        unitOptions: [
          { id: 10, name: '年' },
          { id: 20, name: '月' },
          { id: 30, name: '日' },
          { id: 40, name: '时' },
          { id: 50, name: '分' },
          { id: 60, name: '秒' }
        ]
      }
    },
    created() {
    }
  }
</script>


// WEBPACK FOOTER //
// dealtimeConfig.vue?2173e6b0